function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zM6.15 2.65l1.43 1.43a8.445 8.445 0 00-3.55 6.42h-2c.14-3.2 1.72-6.02 4.12-7.85zm15.82 7.85h-2a8.495 8.495 0 00-3.54-6.42l1.42-1.43c2.39 1.83 3.97 4.65 4.12 7.85zM12.4 21.96A2.014 2.014 0 019.99 20h4c0 .28-.05.54-.15.78-.26.6-.79 1.04-1.44 1.18z",
  fill: "#666"
})));